import { CircularProgress as MuiCircularProgress, CircularProgressProps as MuiCircularProgressProps } from '@mui/material';
import React from 'react';
import AnimatedNumber from 'react-animated-number';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles<{ size: number, thickness: number }>({ name: 'CircularProgress' })((theme, { size, thickness }) => ({
	circularProgress: {
		transform: 'rotate(0deg) !important'
	},
	circularProgressTrail: {
		border: `${thickness}px solid #D8D8D8`,
		borderRadius: '50%',
		position: 'absolute',
		top: 0, left: 0, bottom: 0, right: 0
	},
	root: {
		position: 'relative',
		width: size,
		height: size
	},
	circularProgressLabel: {
		position: 'absolute',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
		fontWeight: 700,
		fontSize: '16px',
		lineHeight: '20px',
		letterSpacing: '0.02em',
		whiteSpace: 'nowrap'
	}
}));

export type CircularProgressProps = Omit<MuiCircularProgressProps, 'size' | 'classes'> & {
	size: number;
	classes?: Partial<ReturnType<typeof useStyles>['classes']>;
};

export const CircularProgress = (props: CircularProgressProps) => {
	const { value, className, classes, size, thickness = 3.6, ...other } = props;
	const { classes: styles, cx } = useStyles({ size, thickness });

	return (
		<div className={cx(styles.root, classes?.root, className)}>
			<div className={cx(styles.circularProgressTrail, classes?.circularProgressTrail)}></div>
			<MuiCircularProgress
				size={size}
				thickness={thickness * (43 / size)}
				className={cx(styles.circularProgress, classes?.circularProgress)}
				value={value}
				{...other} />
			<AnimatedNumber
				className={cx(styles.circularProgressLabel, classes?.circularProgressLabel)}
				value={value}
				duration={300}
				formatValue={(val) => Math.floor(val) + ' %'} />
		</div>
	);
};
